(function() {
  var VARIANT_ID = 50811215741266;

  async function ckRefreshCart() {
    try {
      var cartDrawer = document.querySelector('cart-drawer');
      if (!cartDrawer) { window.location.reload(); return; }
      var sectionsToRender = cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender() : [];
      var uniqueSectionIds = [...new Set(sectionsToRender.map(function(s) { return s.id; }).filter(Boolean))];
      if (!uniqueSectionIds.length) { window.location.reload(); return; }
      var sectionsUrl = new URL(window.location.href);
      sectionsUrl.searchParams.set('sections', uniqueSectionIds.join(','));
      var responses = await Promise.all([
        fetch(sectionsUrl.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } }),
        fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      ]);
      var sections = await responses[0].json();
      var cartState = await responses[1].json();
      cartDrawer.renderContents({ ...cartState, sections: sections });
    } catch(e) {
      window.location.reload();
    }
  }

  // Event Delegation - lauscht auf document statt direkt auf Toggle
  document.addEventListener('change', function(e) {
    if (e.target && e.target.id === 'ck-prio-toggle') {
      var toggle = e.target;
      var widget = document.getElementById('ck-prio-widget');
      if (widget) widget.classList.add('ck-prio--loading');

      if (toggle.checked) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: VARIANT_ID, quantity: 1 }] })
        }).then(function() { ckRefreshCart(); })
        .catch(function() {
          if (widget) widget.classList.remove('ck-prio--loading');
          toggle.checked = false;
        });
      } else {
        var itemKey = toggle.dataset.key;
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: itemKey || VARIANT_ID.toString(), quantity: 0 })
        }).then(function() { ckRefreshCart(); })
        .catch(function() {
          if (widget) widget.classList.remove('ck-prio--loading');
          toggle.checked = true;
        });
      }
    }
  });

})();